<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <h2>Service Reminder Types</h2>
                        <span v-if="loading">
                            Loading... <i class="fa fa-spinner fa-spin" />
                        </span>
                        <span v-if="loaded && types.length === 0">
                            No service reminder types yet.
                        </span>
                    </div>
                    <div class="col-sm-12 col-md-6 text-right">
                        <router-link
                            class="btn btn-info"
                            :to="{name: 'service_reminders'}"
                        >
                            View reminders
                        </router-link>
                        <button
                            class="btn btn-primary"
                            @click.prevent="addType"
                        >
                            <i class="fa fa-plus" /> Add type
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table
                            v-if="loaded && types.length"
                            class="table"
                        >
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Key</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(type, index) in types"
                                    :key="type.id || index"
                                >
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Type name"
                                            class="form-control"
                                            v-model="type.name"
                                            @change="saveType(index)"
                                        >
                                    </td>
                                    <td class="text-muted">
                                        {{ type.slug }}
                                    </td>
                                    <td class="text-right">
                                        <span
                                            v-if="type.saving"
                                            class="text-muted"
                                        >Saving...</span>
                                        <span
                                            v-if="type.saved"
                                            class="text-success"
                                        >Saved</span>
                                        <button
                                            class="btn btn-sm btn-danger"
                                            @click.prevent="deleteType(index)"
                                        >
                                            <i class="fa fa-times" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Service from '../../../services/ServiceReminderTypeService';
import UsesErrors from '../../../mixins/UsesErrors';
import UsesInfoMessage from '../../../mixins/UsesInfoMessage';

export default {
    mixins: [UsesErrors, UsesInfoMessage],

    data() {
        return {
            types: [],
            loading: false,
            loaded: false,
            saving: false,
        };
    },

    mounted() {
        this.loadTypes();
    },

    methods: {
        loadTypes() {
            this.loading = true;
            Service.index().then((res) => {
                this.types = res.data;
                this.loaded = true;
            }).catch((err) => {
                this.showErrorMessage('Error: Failed to load service reminder types');
                this.types = [];
                throw err;
            }).then(() => {
                this.loading = false;
            });
        },

        saveType(index) {
            const type = this.types[index];
            if (!type || !type.name || type.name.trim() === '') {
                return;
            }
            if (this.saving) {
                return;
            }

            this.saving = true;
            this.$set(this.types[index], 'saving', true);
            this.$set(this.types[index], 'saved', false);
            this.setSaving();
            Service.save({
                id: type.id,
                name: type.name.trim(),
            }).then((res) => {
                this.types.splice(index, 1, Object.assign({}, res.data, {
                    saving: false,
                    saved: true,
                }));
                this.clearSaving();
                this.setInfoMessage('Service reminder type saved');
            }).catch((err) => {
                this.clearSaving();
                if (this.types[index]) {
                    this.$set(this.types[index], 'saving', false);
                }
                this.showErrorMessage(this.errorText(err, 'Failed to save service reminder type'));
            }).then(() => {
                this.saving = false;
                if (this.types[index]) {
                    this.$set(this.types[index], 'saving', false);
                }
            });
        },

        deleteType(index) {
            const type = this.types[index];
            if (!type) {
                return;
            }
            if (type.name && !window.confirm('Are you sure you want to delete this service reminder type?')) {
                return;
            }
            if (!type.id) {
                this.types.splice(index, 1);
                return;
            }

            Service.delete(type.id).then(() => {
                this.types.splice(index, 1);
            }).catch((err) => {
                this.showErrorMessage(this.errorText(err, 'Failed to delete service reminder type'));
            });
        },

        addType() {
            this.types.push({
                name: '',
            });
        },

        errorText(err, fallback) {
            if (err.response && err.response.data && err.response.data.errors && err.response.data.errors.name) {
                return err.response.data.errors.name[0];
            }

            return fallback;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/service-reminder-types/IndexComponent.vue